import { FC } from 'react';
import { Button, Icon } from 'learning-panel-components';
import { useSelector } from 'react-redux';
import { selectIsCxUniversity, selectUserFullName, selectUserNickname } from '@redux/slices/userSlice';
import { useNavigate } from 'react-router-dom';
import Certificate from '@components/home/certificates/certificate';
import { translate } from 'translations';
import { coreService } from 'network-utils';
import styles from './quizPlayer.module.scss';

const QuizPlayer: FC<QuizPlayerProps> = (props: QuizPlayerProps) => {
    const { startTest, quizInfo } = props;
    const isCxUniversity = useSelector(selectIsCxUniversity);
    const fullName = useSelector(selectUserFullName);
    const nickname = useSelector(selectUserNickname);
    const navigate = useNavigate();

    const certificateData = {
        name: fullName || nickname,
        entityDisplayName: quizInfo.courseDisplayName,
        endDate: '',
        completedAt: ''
    };

    return (
        <div className={styles['quiz-wrapper']}>
            <div className={styles.back}>
                <div className={styles['back-content']} onClick={(): void => navigate(-1)}>
                    <Icon name="back" className={styles['back-icon']} />
                    <div>{translate('Back')}</div>
                </div>
            </div>
            <div className={styles.content}>
                <div className={styles.left}>
                    <div className={styles['title-sub-title-wrapper']}>
                        <div className={styles['title-wrapper']}>
                            <Icon name="assessmentIconLearningPanel" className={styles.icon} />
                            <div className={styles.title}>{translate('CERTIFICATIONTEST')}</div>
                        </div>
                        <div className={styles['sub-title']}>{quizInfo.courseDisplayName}</div>
                    </div>
                    <img src={quizInfo.courseIcon} alt="course icon" className={styles['course-background']} />
                </div>
                <div className={styles.divider}></div>
                <div className={styles.right}>
                    <div className={styles.title}>{translate('ThisTestIsPreRequistireOfGetting')}</div>
                    <Certificate
                        certificateData={certificateData}
                        isCxUniversity={isCxUniversity}
                        isCustom={true}
                        isOwasp={false}
                        isSkillTree={false}
                        isLearningPath={false}
                        isCertificateDataLoading={false}
                        width="33rem"
                        height="22rem"
                        withOpacity
                    />
                    <div className={styles.title}>{translate('TestDetails')}</div>
                    <div className={styles.stats}>
                        <div className={styles['test-details-wrapper']}>
                            <div className={styles.questions}>
                                <div className={styles.wrapper}>
                                    <div className={styles.number}>{quizInfo.numberOfQuestions}</div>
                                    <div className={styles.text}>{translate('Questions')}</div>
                                </div>
                            </div>
                            <div className={styles['divider-sub']}></div>
                            <div className={styles.mistakes}>
                                <div className={styles.wrapper}>
                                    <div className={styles.number}>{quizInfo.incorrectQuestionsAllowed}</div>
                                    <div className={styles.text}>{translate('MistakesAllowed')}</div>
                                </div>
                            </div>
                        </div>
                        <div className={styles['attempts-wrapper']}>
                            <div className={styles.attempts}>
                                <div className={styles.wrapper}>
                                    <div className={styles.number}>{quizInfo.attemptsAllowed}</div>
                                    <div className={styles.text}>{translate('Attempts')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.button}>
                        <Button
                            id="take-test-button"
                            type={'bigGradient'}
                            onClick={startTest}
                            text={translate('TakeTest')}
                            lowerCase
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

interface QuizPlayerProps {
    quizInfo: coreService.QuizInfo;
    startTest: (quizId: number) => void;
}

export default QuizPlayer;
